<!-- This example requires Tailwind CSS v2.0+ -->
<template>
    <div class="px-4 sm:px-6 lg:px-8">
        <div class="sm:flex sm:items-center">
            <div class="sm:flex-auto">
                <h1 class="text-xl font-semibold text-gray-900">Invoicing</h1>
            </div>
            <div class="mt-4 sm:mt-0 sm:ml-16 sm:flex-none">
                <button @click="addRow" type="button" class="inline-flex items-center justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto">Add new row</button>
            </div>
            <div class="mt-4 sm:mt-0 sm:ml-16 sm:flex-none">
                <button @click="removeRow" type="button" class="inline-flex items-center justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto">Remove row</button>
            </div>
        </div>
        <div class="mt-8 flex flex-col">
            <div class="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div class="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                    <div class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
                        <table class="min-w-full divide-y divide-gray-300">
                            <thead class="bg-gray-50">
                            <tr>
                                <th scope="col" class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">Disbursements</th>
                                <th scope="col" class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"></th>
                                <th scope="col" class="py-3.5 pr-10 text-right font-semibold">Attachments</th>
                            </tr>
                            </thead>
                            <tbody class="divide-y divide-gray-200 bg-white">
                            <tr v-for="row in rows">
                                <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                                    <input type="text" v-model="row.disbursements" placeholder="Fill in disbursements" class="w-full rounded-lg border-gray-200">
                                </td>
                                <td class="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                                    <input type="text" v-model="row.amount" placeholder="Amount" class="text-right rounded-lg border-gray-200"/>
                                </td>
                                <td class="w-20 h-3 p-3">
                                    <Button type="button" v-model="row.attachments" class="bg-indigo-600 text-white">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13" />
                                        </svg>
                                    </Button>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <div class="flex flex-row p-4 items-center w-full justify-end">
                            Total: {{ sum }},-
                        </div>
                    </div>
                    <div class="w-full flex justify-end mt-4">
                        <button @click="handleInput" type="button" class="inline-flex items-center justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto">Export</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import Input from "@/Jetstream/Input";
import Button from "@/Jetstream/Button";
import {ref, computed} from "vue";

const rows = ref([
    {
        disbursements: '',
        attachments: '',
        amount: 0,
    }
]);

function addRow() {
    try {
        rows.value.push( {
            disbursements: '',
            attachments: '',
            amount: 0,
        })
    } catch (e) {
        console.log(e)
    }
}

function removeRow() {
        rows.value.pop();
}


const sum = computed(() => {
    let sum = 0
    for (let i = 0; i < rows.value.length; i++) {
        sum += parseInt(rows.value[i].amount)
    }
    return sum.toLocaleString(undefined)
})




</script>

<style scoped>

</style>
